/* ==========================================================================
   UEL CPD theme: global script
   - Mobile menu
   - UK / USA store switcher (Shopify localization form)
   - Toast notifications   (window.uelToast)
   - Header basket count  (window.uelSetCartCount)
   - Cookie preferences link (Shopify's built-in cookie banner)
   ========================================================================== */
(function () {
  'use strict';

  var docEl = document.documentElement;
  docEl.classList.remove('no-js');
  docEl.classList.add('js');

  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var TOAST_KEY = 'uel-pending-toast';

  /* ---------- Toasts ---------- */

  var ICONS = {
    success: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>',
    info: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>'
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function toast(title, description, type) {
    var toaster = document.querySelector('[data-uel-toaster]');
    if (!toaster) return;

    var el = document.createElement('div');
    el.className = 'uel-toast';
    el.innerHTML =
      '<span class="uel-toast__icon">' + (ICONS[type] || ICONS.success) + '</span>' +
      '<span><span class="uel-toast__title">' + escapeHtml(title) + '</span>' +
      (description ? '<span class="uel-toast__description">' + escapeHtml(description) + '</span>' : '') +
      '</span>';
    toaster.appendChild(el);

    setTimeout(function () {
      el.classList.add('is-leaving');
      setTimeout(function () { el.remove(); }, 200);
    }, 4500);
  }

  window.uelToast = toast;

  // Show a toast queued before a page reload (e.g. after switching store).
  try {
    var pending = sessionStorage.getItem(TOAST_KEY);
    if (pending) {
      sessionStorage.removeItem(TOAST_KEY);
      var data = JSON.parse(pending);
      toast(data.title, data.description, data.type);
    }
  } catch (e) { /* storage unavailable */ }

  function queueToast(title, description, type) {
    try {
      sessionStorage.setItem(TOAST_KEY, JSON.stringify({ title: title, description: description, type: type }));
    } catch (e) { /* storage unavailable */ }
  }

  /* ---------- Basket count ---------- */

  function getCartCount() {
    return parseInt(document.body.getAttribute('data-cart-count') || '0', 10) || 0;
  }

  window.uelSetCartCount = function (count) {
    document.body.setAttribute('data-cart-count', String(count));
    document.querySelectorAll('[data-cart-count-badge]').forEach(function (badge) {
      badge.textContent = count;
      badge.hidden = count < 1;
      badge.classList.remove('uel-bounce');
      void badge.offsetWidth; // restart the animation
      badge.classList.add('uel-bounce');
    });
  };

  /* ---------- Mobile menu ---------- */

  var header = document.querySelector('[data-uel-header]');
  var menuToggle = document.querySelector('[data-menu-toggle]');

  function setMenu(open) {
    if (!header || !menuToggle) return;
    header.classList.toggle('is-menu-open', open);
    menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      setMenu(menuToggle.getAttribute('aria-expanded') !== 'true');
    });

    // Close the menu when a link inside it is clicked, or when resizing to desktop.
    document.querySelectorAll('[data-uel-nav] a').forEach(function (link) {
      link.addEventListener('click', function () { setMenu(false); });
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1024) setMenu(false);
    });
  }

  /* ---------- Store switcher ---------- */

  function closeSwitchers(except) {
    document.querySelectorAll('[data-hub-switcher]').forEach(function (switcher) {
      if (switcher === except) return;
      var trigger = switcher.querySelector('[data-hub-trigger]');
      var list = switcher.querySelector('.uel-hub__list');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (list) list.hidden = true;
    });
  }

  document.querySelectorAll('[data-hub-switcher]').forEach(function (switcher) {
    var trigger = switcher.querySelector('[data-hub-trigger]');
    var list = switcher.querySelector('.uel-hub__list');
    if (!trigger || !list) return;

    trigger.addEventListener('click', function () {
      var open = trigger.getAttribute('aria-expanded') !== 'true';
      closeSwitchers(switcher);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      list.hidden = !open;
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-hub-switcher]')) closeSwitchers(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeSwitchers(null);
      setMenu(false);
    }
  });

  document.querySelectorAll('[data-hub-choice]').forEach(function (choice) {
    choice.addEventListener('click', function () {
      chooseHub(choice);
    });
  });

  function chooseHub(choice) {
    var nextHub = choice.getAttribute('data-hub-choice');
    var label = choice.getAttribute('data-hub-label');
    var country = choice.getAttribute('data-country');
    var form = document.getElementById('UelHubForm');

    closeSwitchers(null);
    if (!form || nextHub === docEl.getAttribute('data-hub')) return;

    var hadItems = getCartCount() > 0;

    // Same behaviour as the Lovable store: switching region empties the basket,
    // because UK and USA courses are different variants with different prices.
    var clearCart = hadItems
      ? fetch(shopRoot + 'cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
        }).catch(function () {})
      : Promise.resolve();

    clearCart.then(function () {
      if (hadItems) {
        queueToast('Switched to the ' + label, 'Your basket was emptied because prices and enrolment differ by region.', 'info');
      } else {
        queueToast('You are now browsing the ' + label, '', 'success');
      }
      form.querySelector('[name="country_code"]').value = country;
      form.submit();
    });
  }

  /* ---------- Cookie preferences (Shopify cookie banner) ---------- */

  function revealCookieLinks() {
    var available = window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    document.querySelectorAll('[data-cookie-preferences]').forEach(function (button) {
      button.hidden = !available;
    });
  }

  document.querySelectorAll('[data-cookie-preferences]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      }
    });
  });

  window.addEventListener('load', function () {
    revealCookieLinks();
    setTimeout(revealCookieLinks, 2000);
  });
})();
